import { render, staticRenderFns } from "./bid-dialog.vue?vue&type=template&id=2e252cfa&scoped=true"
import script from "./bid-dialog.vue?vue&type=script&lang=js"
export * from "./bid-dialog.vue?vue&type=script&lang=js"
import style0 from "./bid-dialog.vue?vue&type=style&index=0&id=2e252cfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e252cfa",
  null
  
)

export default component.exports